module.exports = __webpack_public_path__ + "media/images/app_coin-aea083690a48878208f0be2473ba9025.png";